var _style, _defs, _path, _defs2, _path2, _defs3, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVrbo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 31.59",
    style: {
      enableBackground: "new 0 0 32 31.59"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000043440177581613071600000003688667202489603727_);}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#318EEE;}\n\t.st2{clip-path:url(#SVGID_00000173136839201053134420000008022340450969506716_);}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#245ABC;}\n\t.st4{clip-path:url(#SVGID_00000064334612586901964760000011223982315240963502_);}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#1C4695;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#E85F24;}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#8EC089;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0.01,
    width: 9.19,
    height: 31.58
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000120525354448077464960000013948925708956964487_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000120525354448077464960000013948925708956964487_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,0h1.76c0.45,0.81,0.76,1.68,1.02,2.56C3.06,3.49,3.28,4.44,3.48,5.4c1.63,7.54,3.26,15.08,4.89,22.63 c0.26,1.19,0.51,2.38,0.77,3.56H7.73c0-0.09-0.03-0.18-0.05-0.27C5.8,22.65,3.93,13.99,2.05,5.33C1.83,4.29,1.57,3.26,1.21,2.26 C0.91,1.46,0.54,0.67,0,0z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000152233200090532381430000000395129305685734528_",
    x: 3.41,
    y: 0.01,
    width: 8.53,
    height: 31.58
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000163764380931021234340000008138508824243320460_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152233200090532381430000000395129305685734528_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000163764380931021234340000008138508824243320460_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3.46,0h1.65c0.27,1.51,0.62,3,0.97,4.49c1.6,7.4,3.2,14.81,4.8,22.21c0.35,1.63,0.7,3.25,1.06,4.88h-1.39 c-0.3-1.38-0.6-2.76-0.9-4.14c-1.6-7.42-3.21-14.85-4.81-22.27C4.67,4.39,4.47,3.62,4.28,2.85C4.04,1.89,3.81,0.92,3.46,0z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000044898495785486786370000007995731755448135314_",
    x: 6.56,
    y: 0.01,
    width: 25.44,
    height: 31.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036974313573789276240000010506585800428510134_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044898495785486786370000007995731755448135314_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000036974313573789276240000010506585800428510134_)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M6.69,0h1.67C8.3,1.28,8.49,2.56,8.74,3.81C8.83,4.25,8.93,4.67,9.03,5.1c1.72,8.12,3.44,16.24,5.16,24.36 c-0.3,0.64-0.61,1.28-0.91,1.93c-0.16-0.71-0.31-1.43-0.46-2.14c-1.35-6.24-2.69-12.48-4.04-18.72c-0.51-2.34-1-4.68-1.52-7.02 C7.01,2.34,6.79,1.18,6.69,0z M29.79,0H32c-0.68,0.45-1.33,0.94-1.92,1.5c-1.36,1.27-2.45,2.8-3.45,4.36 c-1.07,1.69-2.04,3.45-2.98,5.22c-0.03-0.02-0.07-0.04-0.1-0.06c0.11-0.24,0.22-0.47,0.33-0.7c0.86-1.81,1.72-3.61,2.66-5.38 c0.5-0.94,1.02-1.87,1.6-2.77C28.64,1.4,29.17,0.67,29.79,0z"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M9.98,0h1.73c-0.16,0.57-0.23,1.16-0.24,1.74c-0.01,1.18,0.16,2.36,0.38,3.51c1.36,6.59,2.73,13.19,4.09,19.78 c0.03,0.18,0.08,0.35,0.1,0.53c-0.04,0.12-0.11,0.23-0.16,0.34c-0.26,0.53-0.51,1.07-0.77,1.61c-1.46-6.99-2.93-13.99-4.4-20.98 c-0.24-1.15-0.5-2.29-0.66-3.46C9.93,2.06,9.84,1.02,9.98,0z M26.48,0h1.8c-0.44,0.82-0.83,1.67-1.22,2.52 c-0.4,0.89-0.79,1.79-1.17,2.69c-0.81,1.91-1.62,3.83-2.42,5.74c-0.03-0.02-0.06-0.04-0.1-0.07c0.52-1.43,1.03-2.86,1.53-4.3 c0.36-1.06,0.71-2.12,1-3.2C26.19,2.29,26.43,1.15,26.48,0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M13.54,0h1.74c-0.55,0.71-0.75,1.62-0.8,2.5c-0.05,1.22,0.16,2.43,0.4,3.61c0.98,4.98,1.95,9.96,2.93,14.94 c0.03,0.2,0.09,0.39,0.11,0.59c-0.05,0.14-0.12,0.26-0.18,0.4c-0.25,0.52-0.5,1.04-0.75,1.57c-1.15-5.74-2.29-11.48-3.44-17.22 c-0.1-0.53-0.22-1.06-0.31-1.6c-0.1-0.6-0.17-1.21-0.19-1.82C13.02,1.97,13.11,0.93,13.54,0z M23.63,0h1.59 c0.11,0.42,0.15,0.86,0.16,1.29c0.02,1.06-0.16,2.1-0.37,3.13c-0.24,1.15-0.55,2.29-0.86,3.43c-0.28,1-0.58,1.99-0.88,2.98 c-0.03-0.02-0.07-0.05-0.1-0.07c0.37-1.48,0.71-2.96,0.94-4.47c0.18-1.21,0.31-2.44,0.23-3.66C24.29,1.72,24.11,0.79,23.63,0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVrbo);
export default __webpack_public_path__ + "static/media/vrbo.117aca4d7195edf56a0ac5d48f8e2a73.svg";
export { ForwardRef as ReactComponent };